import {
  PropertySearchDetailsState,
  PropertySearchDetailsActionTypes,
  PROPERTY_SEARCH_DETAILS_ADD,
  PROPERTY_SEARCH_DETAILS_CLEAR,
  PROPERTY_SEARCH_DETAILS_LOADING,
} from './PropertySearchDetails.types';

const defaultState: PropertySearchDetailsState = {
  details: null,
  loading: false,
};

export function propertySearchDetailsReducer(
  state = defaultState,
  action: PropertySearchDetailsActionTypes,
): PropertySearchDetailsState {
  switch (action.type) {
    case PROPERTY_SEARCH_DETAILS_CLEAR: {
      return {
        ...defaultState,
      };
    }
    case PROPERTY_SEARCH_DETAILS_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case PROPERTY_SEARCH_DETAILS_ADD: {
      return {
        ...state,
        details: action.payload,
      };
    }
    default:
      return state;
  }
}
